/**
 * 逐笔申报
 */
import React, { useEffect, useState } from "react"
import { getBondZBSBData } from "../../../../modules/quote/web"
import { LoadStatus } from "../../load_status"
import { getSettleMethod, getSettlePeriod, getTradeDirection, returnTransactionMode, DeclareDataType, TransactionType } from "../../utils"

export function Declaration(props: { quotecode: string }) {
  const [currentType, setCurrentType] = useState(TransactionType.全部成交)
  const [pageSize, setPageSize] = useState(20)
  const [transactionData, setTransationData] = useState([])

  let currentTypeList = [TransactionType.全部成交, TransactionType.匹配成交, TransactionType.点击成交, TransactionType.意向申报]

  let titleArr: Array<DeclareDataType> = []

  let fieldArr = [
    { tps: 0, fields2: "f51,f52,f53,f54,f55" }, // 全部成交
    { tps: 1, fields2: "f51,f52,f53,f54,f56,f57" }, // 匹配成交 依次是时间,买卖方向,价格,数量,交易方式,结算周期
    { tps: 4, fields2: "f51,f52,f53,f54,f56,f57,f58,f59" }, // 点击成交
    { tps: 8, fields2: "f51,f52,f53,f54,f56,f57,f58,f59" }, // 意向申报
    { tps: 32,pod: 1, fields2: "f52,f53,f54,f58" }, // 竞买成交
  ]

  if (currentType == TransactionType.全部成交) {
    titleArr = [DeclareDataType.时间, DeclareDataType.买卖方向, DeclareDataType.价格, DeclareDataType.数量, DeclareDataType.交易方式]
  } else if (currentType == TransactionType.匹配成交) {
    titleArr = [DeclareDataType.时间, DeclareDataType.买卖方向, DeclareDataType.价格, DeclareDataType.数量]
  } else if (currentType == TransactionType.点击成交) {
    titleArr = [DeclareDataType.时间, DeclareDataType.买卖方向, DeclareDataType.价格, DeclareDataType.数量, DeclareDataType.未知, DeclareDataType.结算方式, DeclareDataType.结算周期, DeclareDataType.交易商, DeclareDataType.交易员]
  } else if (currentType == TransactionType.意向申报) {
    titleArr = [DeclareDataType.时间, DeclareDataType.买卖方向, DeclareDataType.价格, DeclareDataType.数量, DeclareDataType.未知, DeclareDataType.结算方式, DeclareDataType.结算周期]
  }

  useEffect(() => {
    ;(async () => {
      let data = await getBondZBSBData(props.quotecode, fieldArr[currentType], pageSize)
      if (data?.data?.order && data.data.order.length) {
        let temp = data.data.order.map((v: any) => {
          return v.split(",")
        })
        setTransationData(temp)
      } else {
        setTransationData([])
      }
    })()
  }, [currentType, pageSize])

  return (
    <>
      <div className="stock-bj-declare">
        <dl className="stock-bj-declare-nav">
          {currentTypeList.map((item: any) => {
            return (
              <dd
                className={item == currentType ? "bj-tab-active" : ""}
                onClick={(e) => {
                  e.preventDefault()
                  setCurrentType(item)
                }}
                key={item}
              >
                <span>{TransactionType[item]}</span>
              </dd>
            )
          })}
        </dl>
        {transactionData.length > 0 && (
          <div className="stock-bj-table">
            <table cellPadding="0" cellSpacing="0" width="100%">
              <thead>
                <tr>
                  {titleArr.map((item: number, index: number) => {
                    if (item != 99)
                      return (
                        <th key={item} className={index == 0 ? "fixed-colume" : ""}>
                          {DeclareDataType[item]}
                        </th>
                      )
                  })}
                </tr>
              </thead>
              <tbody>
                {transactionData.map((item: any, index: number) => {
                  return (
                    <tr key={index}>
                      {item.map((v: any, i: number) => {
                        return (
                          <React.Fragment key={i}>
                            {i == titleArr[0] && <td className="fixed-colume">{item[0]}</td>}
                            {i == titleArr[1] && <td>{getTradeDirection(item[1])}</td>}
                            {i == titleArr[2] && <td>{item[2]}</td>}
                            {i == titleArr[3] && <td>{item[3]}</td>}
                            {i == titleArr[4] && <td>{returnTransactionMode(item[4])}</td>}
                            {i == titleArr[5] && <td>{getSettleMethod(item[5])}</td>}
                            {i == titleArr[6] && <td>{getSettlePeriod(item[6])}</td>}
                            {i == titleArr[7] && <td>{item[7]}</td>}
                            {i == titleArr[8] && <td>{item[8]}</td>}
                          </React.Fragment>
                        )
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {transactionData.length > 0 &&
        (pageSize == transactionData.length ? (
          <div
            className="stock-bj-loadmore"
            onClick={(e) => {
              e.preventDefault()
              setPageSize(pageSize + 10)
            }}
          >
            查看更多
            <i className="arrow-down"></i>
          </div>
        ) : (
          <LoadStatus icon={false} className="com_tips" title="已经加载到底了" />
        ))}
      {transactionData.length == 0 && <LoadStatus icon={false} className="com_tips" title="该品种暂无相关内容" />}
    </>
  )
}
